export default function alert({ variables }) {
    return {
        MuiAlert: {
            defaultProps: {
                variant: "outlined",
            },
            styleOverrides: {
                root: {
                    borderRadius: variables.border_radius_small,
                    fontSize: variables.type_body_sm_font_size,
                    padding: `${variables.spacing_02} ${variables.spacing_04}`,
                    alignItems: "center",
                },
                icon: {
                    padding: 0,
                    marginRight: variables.spacing_03,
                    fontSize: 18,
                    opacity: 1,
                },
                message: {
                    padding: 0,
                    lineHeight: variables.type_body_sm_line_height,
                },
                action: {
                    padding: 0,
                    marginRight: 0,
                    marginLeft: variables.spacing_03,
                },
                standard: {
                    backgroundColor: variables.surface_subtle,
                    border: `1px solid ${variables.border_subtle}`,
                },
            },
        },
        MuiAlertTitle: {
            styleOverrides: {
                root: {
                    fontSize: variables.type_body_font_size,
                    fontWeight: variables.font_weight_semibold,
                    marginBottom: variables.spacing_01,
                    lineHeight: 1.35,
                },
            },
        },
    };
}
//# sourceMappingURL=alert.js.map